// extracted by mini-css-extract-plugin
module.exports = {"error_block":"_pVpxXnhC"};